import Vue from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'
import '@/assets/tailwindcss.css'

import 'fullpage.js/dist/fullpage.css'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage)

Vue.use(VueGtag, {
  config: { id: 'UA-156016-28' }
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
